export default {
  SUBMIT_CARGA_INDEX: 'SUBMIT_CARGA_INDEX',
  SUBMIT_CARGA_INDEX_SUCCESS: 'SUBMIT_CARGA_INDEX_SUCCESS',
  ABRIR_MODAL_CARGA_INDEX: 'ABRIR_MODAL_CARGA_INDEX',
  CERRAR_MODAL_CARGA_INDEX: 'CERRAR_MODAL_CARGA_INDEX',
  SUBIR_ARCHIVOS_CARGA_INDEX: 'SUBIR_ARCHIVOS_CARGA_INDEX',
  DESCARGAR_PLANTILLA_CSV: 'DESCARGAR_PLANTILLA_CSV'
}